import { DateTime } from 'luxon';

export const DATE_TIME_DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_TIME_ISO_DATE_FORMAT = 'yyyy-MM-dd';
export const DATE_TIME_TIME_FORMAT = 'HH:mm';
export const DATE_TIME_DATE_TIME_FORMAT = DATE_TIME_DATE_FORMAT + ', ' + DATE_TIME_TIME_FORMAT;
export const DATE_TIME_NON_ZULU_ISO_DATE_TIME_FORMAT = DATE_TIME_ISO_DATE_FORMAT + "'T'" + DATE_TIME_TIME_FORMAT; // T must be escaped with ' else it will be interpreted

export function areSameDate(left: DateTime, right: DateTime): boolean {

    if (left === undefined && right === undefined) {
        return true;
    }

    if (left === undefined || right === undefined) {
        return false;
    }

    return left.toFormat(DATE_TIME_DATE_TIME_FORMAT) === right.toFormat(DATE_TIME_DATE_TIME_FORMAT);
}
